import { capitalize } from "lodash-es";

import { UserSeatPreference } from "Bands/types";
import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { userFlightPreferences } = copy;

export const fields: IFormFields = [
  {
    name: "flightPreferences.seatPreference",
    label: userFlightPreferences.fields.seatPreference.title,
    placeholder: userFlightPreferences.fields.seatPreference.placeholder,
    type: IFieldType.select,
    options: (Object.keys(UserSeatPreference) as Array<keyof typeof UserSeatPreference>).map(
      key => ({
        value: UserSeatPreference[key],
        label: capitalize(UserSeatPreference[key].replaceAll("_", " ")),
      })
    ),
  },
];
